import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { filter, map } from 'rxjs/operators';
import {
	Announcement,
	CommunicationEvents,
	SubscriptionStatus
} from '@models/subscription.model';
import { SNModalService } from '@web-services/modal/snModal.service';
import { IframeService } from '@services/helpers/iframe-service/iframe.service';

@Component({
	selector: 'subscription-announcement-banner',
	template: require('./subscription-announcement-banner.html'),
	styles: [require('./subscription-announcement-banner.scss')]
})
export class SubscriptionAnnouncementBannerComponent
	implements OnInit, OnDestroy {
	announcementData: Announcement;
	actionList: Array<string> = [];

	private checkoutPlanOpenEvent;
	private confirmPaymentOpenEvent;
	private billingOpenEvent;
	private updateOpenEvent;
	private disableButton: boolean;

	constructor(
		private subscriptionService: NewSubscriptionServiceDataProvider,
		private snModalService: SNModalService,
		private iframeService: IframeService,
		private renderer: Renderer2
	) {}

	ngOnInit(): void {
		this.attachEventHandlers();
		this.getAnnouncementData();
	}

	ngOnDestroy(): void {
		this.detachEventListeners();
	}

	loadIframe(url: string): void {
		this.disableButton = true;
		this.iframeService.setUrlIframe(url);
	}

	openChoosePlanModal(): void {
		this.subscriptionService.setChoosePlanOpenModalStatus({
			state: true,
			payload: null
		});
	}

	attachEventHandlers(): void {
		this.onConfirmPaymentPaymentOpen();
		this.onCheckoutOpenEvent();
		this.onEditBillingModalIframeOpen();
		this.onUpdatePaymentClose();
	}

	detachEventListeners(): void {
		this.checkoutPlanOpenEvent();
		this.confirmPaymentOpenEvent();
		this.billingOpenEvent();
		this.updateOpenEvent();
	}

	private getAnnouncementData(): void {
		this.subscriptionService.subscriptionData.subscribe(
			(data: SubscriptionStatus): void => {
				if (data && data.announcements.length) {
					this.announcementData = data.announcements[0];
					this.actionList = this.subscriptionService.createActionList(
						this.announcementData.actions
					);
				} else {
					this.announcementData = null;
				}
			}
		);
	}

	private onConfirmPaymentPaymentOpen(): void {
		this.confirmPaymentOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.confirmPaymentOpen,
			() => {
				this.disableButton = false;
			}
		);
	}

	private onCheckoutOpenEvent(): void {
		this.checkoutPlanOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.planCheckoutOpen,
			() => {
				this.disableButton = false;
			}
		);
	}

	private onEditBillingModalIframeOpen(): void {
		this.billingOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.billingUpdateOpen,
			(): void => {
				this.disableButton = false;
			}
		);
	}

	private onUpdatePaymentClose(): void {
		this.updateOpenEvent = this.renderer.listen(
			'document',
			CommunicationEvents.updatePaymentOpen,
			(): void => {
				this.disableButton = false;
			}
		);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/subscription/subscription-announcement-banner/subscription-announcement-banner.ts